export default {
  storefront_not_found: {
    title: 'Storefrontia ei löytynyt',
    description: 'Luo Storefront.',
  },
};
